import { makeStyles } from '@material-ui/core/styles'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
	csvButton: {
		textDecoration: 'none',
		color: 'black',
	},
}))

function PurchaseTableCSV({ getFilteredRows }: { getFilteredRows: any }) {
	console.log('getFilteredRows: ', getFilteredRows)
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const { t: tPurchases } = useTranslation('purchases')

	const [currentLanguage, setCurrentLanguage] = useState('en')
	const [csvData, setCsvData] = useState([])

	useEffect(() => {
		setCurrentLanguage(i18n.language)
	}, [i18n.language])

	const headers = [
		{ label: tPurchases('csv.date'), key: 'date' },
		{
			label: tPurchases('csv.purchaseOrderNumber'),
			key: 'purchaseOrderNumber',
		},
		{
			label: tPurchases('csv.fullPurchaseNumber'),
			key: 'fullPurchaseNumber',
		},
		{ label: tPurchases('csv.supplier'), key: 'supplierName' },
		{ label: tPurchases('csv.supplierType'), key: 'supplierType' },
		{ label: tPurchases('csv.costline'), key: 'costlineName' },
		{ label: tPurchases('csv.quote'), key: 'quoteName' },
		{ label: tPurchases('csv.project'), key: 'projectName' },
		{ label: tPurchases('csv.projectNumber'), key: 'projectNumber' },
		{ label: tPurchases('csv.quoteNumber'), key: 'quoteNumber' },
		{ label: tPurchases('csv.invoiceNumber'), key: 'invoiceNumber' },
		{ label: tPurchases('csv.amountBudget'), key: 'provAmount' },
		{ label: tPurchases('csv.po'), key: 'poAvailable' },
		{ label: tPurchases('csv.status'), key: 'status' },
	]

	const handleCsvData = () => {
		if (getFilteredRows.length > 0) {
			const newData: any = []
			getFilteredRows
				?.filter((p: any) => p.groupType !== 'secondary')
				?.map((costline: any) => {
					// let currentSupplier = suppliersData.filter(sd => sd.id === costline.supplierId)[0]
					// let quoteName = quoteData.filter(qd => qd.id === costline.quoteId)[0].name
					// let projectId = quoteData.filter(qd => qd.id === costline.quoteId)[0].parentProjectId
					// let projectName = projectData.filter(pd => pd.id === projectId)[0].name

					const individualRow = {
						date: dayjs(costline.createdOn).format('DD/MM/YYYY'),
						purchaseOrderNumber: costline?.purchaseOrderNumber,
						fullPurchaseNumber: costline?.fullPurchaseNumber,
						supplierName: costline.supplierName,
						supplierType: costline.supplierType,
						costlineName:
							currentLanguage === 'en'
								? costline.recapCostlineItem
								: costline.recapCostlineItem_fr,
						quoteName: costline.quoteName,
						projectName: costline.projectName,
						projectNumber: costline.projectNumber,
						quoteNumber: costline.quoteNumber,
						invoiceNumber: costline.invoiceNumber,
						provAmount: costline.provisionalTotal
							? costline.provisionalTotal
							: '0',
						poAvailable: costline.poAvailable ? 'Yes' : 'No',
						status: tPurchases(`status.${costline.paymentStatus}`),
					}
					newData.push(individualRow)
				})
			setCsvData(newData)
		}
	}

	return (
		<CSVLink
			data={csvData}
			headers={headers}
			onClick={() => {
				handleCsvData()
			}}
			filename={'PurchaseTableData.csv'}
			className={classes.csvButton}
			target="_blank"
		>
			{tPurchases('csv.exportPurchasesTable')}
		</CSVLink>
	)
}

export default PurchaseTableCSV
